export default "__VITE_ASSET__b699a85b__"